import * as requests from '@cbgms/api/modules/orderaccount/requests'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { GETDefaultOrderAccountReponse, GETOrderAccountResponse } from '@cbgms/api'

export const setNewDefaultOrderAccount = (OrderAccountUUID: string) => ({
  type: [types.SET_DEFAULT_ORDER_ACCOUNT, types.SET_DEFAULT_ORDER_ACCOUNT_SUCCESS, types.SET_DEFAULT_ORDER_ACCOUNT_FAILD],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: '/modules/wholesaler/order-account/settings',
      data: { DefaultOrderAccountUUID: OrderAccountUUID }
    }
  }
})

export const getNewDefaultOrderAccount = () =>
  AsyncAction<GETDefaultOrderAccountReponse>({
    type: [types.GET_DEFAULT_ORDER_ACCOUNT, types.GET_DEFAULT_ORDER_ACCOUNT_SUCCESS, types.GET_DEFAULT_ORDER_ACCOUNT_FAILD],
    payload: {
      api: 'gms',
      request: requests.getNewDefaultOrderAccount()
    }
  })

export const getDefaultOrderAccountDetails = (UUID: string) =>
  AsyncAction<GETOrderAccountResponse>({
    type: [
      types.GET_DEFAULT_ORDER_ACCOUNT_DETAILS,
      types.GET_DEFAULT_ORDER_ACCOUNT_DETAILS_SUCCESS,
      types.GET_DEFAULT_ORDER_ACCOUNT_DETAILS_FAILED
    ],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/wholesaler/order-account/${UUID}/with-related`
      }
    }
  })

export const getOrderAccountDetails = (UUID: string) =>
  AsyncAction<GETOrderAccountResponse>({
    type: [types.GET_ORDER_ACCOUNT_DETAILS, types.GET_ORDER_ACCOUNT_DETAILS_SUCCESS, types.GET_ORDER_ACCOUNT_DETAILS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/wholesaler/order-account/${UUID}/with-related`
      }
    }
  })
